import { useEffect, useRef, useState } from 'react';
import s from './CustomCursor.module.scss';
import classnames from 'classnames';

export const CustomCursor: React.FC<{
  children: React.ReactNode;
  className?: string;
  clickingClassName?: string;
}> = ({ children, className, clickingClassName }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const cursorRef = useRef<HTMLDivElement | null>(null);

  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [clicking, setClicking] = useState(false);
  const c = classnames.bind(s);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const cursor = cursorRef.current;

    if (!wrapper || !cursor) return;

    const onMouseMove = (e: MouseEvent) => {
      const rect = wrapper.getBoundingClientRect();
      setCoords({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      });
    };

    const onMouseEnter = () => setVisible(true);
    const onMouseLeave = () => setVisible(false);
    const onMouseDown = () => setClicking(true);
    const onMouseUp = () => setClicking(false);

    wrapper.addEventListener('mousemove', onMouseMove);
    wrapper.addEventListener('mouseenter', onMouseEnter);
    wrapper.addEventListener('mouseleave', onMouseLeave);
    window.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mouseup', onMouseUp);

    return () => {
      wrapper.removeEventListener('mousemove', onMouseMove);
      wrapper.removeEventListener('mouseenter', onMouseEnter);
      wrapper.removeEventListener('mouseleave', onMouseLeave);
      window.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  return (
    <div ref={wrapperRef} className={s.cursorWrapper}>
      <div
        ref={cursorRef}
        className={c(className, s.customCursor, clicking && clickingClassName)}
        style={{
          transform: `translate(${coords.x}px, ${coords.y}px) translate(-50%, -50%)`,
          opacity: visible ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};
